module.exports = __webpack_public_path__ + "static/media/phone_2.b0116db3.png";